import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import buoyIcon from '../../assets/pictures/buoy.png';

import css from './Topbar.css';

const MenuIcon = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.rootMenuIcon, className);

  return (
    <img src={buoyIcon} alt='buoy' className={classes} />
  );
};

const { string } = PropTypes;

MenuIcon.defaultProps = {
  className: null,
  rootClassName: null,
};

MenuIcon.propTypes = {
  className: string,
  rootClassName: string,
};

export default MenuIcon;



// WEBPACK FOOTER //
// ./src/components/Topbar/MenuIcon.js